import { useState, useEffect } from 'react';

const DEFAULT_SELECTED_ITEMS = {
  factory: null,
  workshop: null,
  section: null,
  room: null,
  camera: null,
};

/**
 * Хук для сохранения/восстановления навигации по уровням (завод → цех → ... → камера).
 * Состояние сохраняется в sessionStorage по ключу storageKey.
 */
export const useNavigationState = (storageKey) => {
  const [currentLevel, setCurrentLevel] = useState(() => {
    try {
      const saved = sessionStorage.getItem(storageKey);
      if (saved) {
        const { level } = JSON.parse(saved);
        return level || 'factories';
      }
    } catch {}
    return 'factories';
  });

  const [selectedItems, setSelectedItems] = useState(() => {
    try {
      const saved = sessionStorage.getItem(storageKey);
      if (saved) {
        const { items } = JSON.parse(saved);
        return items || { ...DEFAULT_SELECTED_ITEMS };
      }
    } catch {}
    return { ...DEFAULT_SELECTED_ITEMS };
  });

  // Сохраняем при каждом изменении
  useEffect(() => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        level: currentLevel,
        items: selectedItems,
      }));
    } catch {}
  }, [currentLevel, selectedItems, storageKey]);

  return { currentLevel, setCurrentLevel, selectedItems, setSelectedItems };
};
